<script>
import {defineComponent, onMounted, ref} from 'vue'
import FormattedNumberInput from "@js/components/Input/FormattedNumberInput.vue"
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue"
import {useCalculatorStore} from "@js/store/CalculatorStore.js"

export default defineComponent({
    name: "BathroomCalculator",
    components: {NumberFormatComponent, FormattedNumberInput},
    setup() {
        const calculatorStore = useCalculatorStore()
        const isClient = ref(false);

        // Безопасный запуск расчета только на клиенте (не SSR)
        onMounted(() => {
            isClient.value = true
            if (calculatorStore.validateTileCalc()) {
                calculatorStore.tileCalculate()
            }
        })

        return {calculatorStore, isClient}
    }
})
</script>

<template>
    <div class="grid grid-cols-12 gap-5 md:gap-10">
        <div class="col-span-12 md:col-span-7">
            <div class="md:bg-grayBg md:rounded-lg md:p-8">
                <div>
                    <div class="mb-5">
                        <p v-if="calculatorStore.tile_calc.error_message"
                           class="text-red-600 font-bold">
                            {{ calculatorStore.tile_calc.error_message }}
                        </p>
                        <p class="text-xl font-semibold mb-5">
                            Вид расчета
                        </p>
                        <div class="w-full inline-flex bg-gray-200 text-black rounded-lg font-semibold">
                            <button
                                @click.prevent="calculatorStore.tile_calc.type = calculatorStore.tile_calc.types.wall"
                                class="w-full px-5 md:px-10 py-2.5 text-sm md:uppercase rounded-lg focus:outline-none transition"
                                :class="[calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.wall
                                            ? 'bg-baseColor border border-gray-300'
                                            : 'bg-gray-200',
                                        ]">
                                Плитка настенная
                            </button>
                            <button
                                @click.prevent="calculatorStore.tile_calc.type = calculatorStore.tile_calc.types.floor"
                                class="w-full px-5 md:px-10 py-2.5 text-sm md:uppercase rounded-lg focus:outline-none transition"
                                :class="[
                                          calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.floor
                                            ? 'bg-baseColor border border-gray-300'
                                            : 'bg-gray-200',
                                        ]">
                                Плитка напольная
                            </button>
                        </div>
                    </div>
                    <div class="mb-5 md:mb-10">
                        <p class="text-xl font-semibold mb-5">
                            Размеры помещения
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcrs_length" id="tcrs_length"
                                                      v-model="calculatorStore.tile_calc.calc_data.room.length"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcrs_length"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Длина (м)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcrs_width" id="tcrs_width"
                                                      v-model="calculatorStore.tile_calc.calc_data.room.width"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcrs_width"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Ширина (м)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group"
                                 v-if="calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.wall">
                                <FormattedNumberInput name="tcrs_height" id="tcrs_height"
                                                      v-model="calculatorStore.tile_calc.calc_data.room.height"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcrs_height"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Высота (м)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5 md:mb-10"
                         v-if="calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.wall">
                        <p class="text-xl font-semibold mb-5">
                            Размеры ванны
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcbs_length" id="tcbs_length"
                                                      v-model="calculatorStore.tile_calc.calc_data.bath.length"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcbs_length"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Длина (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcbs_width" id="tcbs_width"
                                                      v-model="calculatorStore.tile_calc.calc_data.bath.width"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcbs_width"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Ширина (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcbs_height" id="tcbs_height"
                                                      v-model="calculatorStore.tile_calc.calc_data.bath.height"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcbs_height"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Высота (мм)
                                </label>
                            </div>
                        </div>
                        <div class="flex items-center mb-4">
                            <input id="default-checkbox" type="checkbox" value=""
                                   v-model="calculatorStore.tile_calc.calc_data.bath.is_adjacent_to_wall_on_three_sides"
                                   class="w-4 h-4 text-baseColor bg-gray-100 border-gray-300 rounded-sm focus:ring-0">
                            <label for="default-checkbox" class="ms-2 text-sm font-medium text-gray-900">
                                Ванна прилегает к стене с трех сторон
                            </label>
                        </div>
                        <div class="flex items-center">
                            <input checked id="checked-checkbox" type="checkbox" value=""
                                   v-model="calculatorStore.tile_calc.calc_data.bath.include_screen"
                                   class="w-4 h-4 text-baseColor bg-gray-100 border-gray-300 rounded-sm focus:ring-0">
                            <label for="checked-checkbox" class="ms-2 text-sm font-medium text-gray-900">
                                Укладывать экран
                            </label>
                        </div>
                    </div>
                    <div class="mb-5 md:mb-10"
                         v-if="calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.wall">
                        <p class="text-xl font-semibold mb-5">
                            Размеры двери
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcds_width" id="tcds_width"
                                                      v-model="calculatorStore.tile_calc.calc_data.door.width"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcds_width"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Ширина (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcds_height" id="tcds_height"
                                                      v-model="calculatorStore.tile_calc.calc_data.door.height"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcds_height"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Высота (мм)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5 md:mb-10">
                        <p class="text-xl font-semibold mb-5">
                            Плитка
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcts_length" id="tcts_length"
                                                      v-model="calculatorStore.tile_calc.calc_data.tile.length"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcts_length"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Длина (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcts_width" id="tcts_width"
                                                      v-model="calculatorStore.tile_calc.calc_data.tile.width"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcts_width"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Ширина (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcts_price" id="tcts_price"
                                                      v-model="calculatorStore.tile_calc.calc_data.tile.price"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcts_price"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Стоимость (м2/руб)
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="mb-5 md:mb-10">
                        <p class="text-xl font-semibold mb-5">
                            Дополнительно
                        </p>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
                            <div class="relative z-0 w-full group">
                                <FormattedNumberInput name="tcadsv_length" id="tcadsv_length"
                                                      v-model="calculatorStore.tile_calc.calc_data.extra.seam_width"
                                                      class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer"
                                                      placeholder=" "/>
                                <label for="tcadsv_length"
                                       class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-black peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                    Ширина шва (мм)
                                </label>
                            </div>
                            <div class="relative z-0 w-full group">
                                <select id="tcadsv_podrezka"
                                        v-model="calculatorStore.tile_calc.calc_data.extra.layout"
                                        class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer">
                                    <option value="прямая раскладка" selected>
                                        Прямая раскладка
                                    </option>
                                    <option value="со смещением">Со смещением</option>
                                    <option value="по диагонали">По диагонали</option>
                                    <option value="">Нет</option>
                                </select>
                            </div>
                            <div class="relative z-0 w-full group">
                                <select id="tcadsv_zapas"
                                        v-model="calculatorStore.tile_calc.calc_data.extra.reserve"
                                        class="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-black peer">
                                    <option value="5" selected>
                                        Запас 5%
                                    </option>
                                    <option value="10">
                                        Запас 10%
                                    </option>
                                    <option value="15">
                                        Запас 15%
                                    </option>
                                    <option value="0">
                                        Нет
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <button type="button"
                            @click.prevent="calculatorStore.tileCalculate"
                            class="flex items-center justify-center w-full gap-2 leading-tight uppercase text-nowrap bg-baseColor md:hover:bg-baseColor/80 text-black focus:outline-none focus:ring-0 font-bold rounded-xl text-sm px-5 py-4 transition mt-5">
                        Рассчитать
                    </button>
                    <div class="mt-5 pt-5 border-t border-gray-300"
                         v-if="isClient && calculatorStore.tile_calc.is_calculated">
                        <p class="text-xl font-semibold mb-5">
                            Результат расчета:
                        </p>
                        <div class="grid grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5 mb-4">
                            <div
                                class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Площадь укладки
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    {{ calculatorStore.tile_calc.result.totalArea }} м²
                                </div>
                            </div>
                            <div
                                class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Стоимость
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    <NumberFormatComponent :number="calculatorStore.tile_calc.result.totalCost"
                                                           append_text=" ₽"/>
                                </div>
                            </div>
                            <div
                                class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Количество плитки
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    <NumberFormatComponent :number="calculatorStore.tile_calc.result.tileCount"
                                                           append_text=" шт"/>
                                </div>
                            </div>
                            <div v-if="calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.wall"
                                 class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Площадь двери
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    {{ calculatorStore.tile_calc.result.doorArea }} м²
                                </div>
                            </div>
                            <div v-if="calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.wall"
                                 class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Площадь ванны
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    {{ calculatorStore.tile_calc.result.bathArea }} м²
                                </div>
                            </div>
                            <div v-if="calculatorStore.tile_calc.type === calculatorStore.tile_calc.types.wall"
                                 class="flex flex-col justify-between bg-white rounded-2xl p-5 md:p-6 shadow transition-shadow md:hover:shadow-lg">
                                <div class="font-bold text-sm text-gray-600">
                                    Площадь экрана
                                </div>
                                <div
                                    class="font-semibold whitespace-pre-line break-words text-xl md:text-2xl mt-2">
                                    {{ calculatorStore.tile_calc.result.screenArea }} м²
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-span-12 md:col-span-5">
            <div>
                <img src="@img/calculator/info.webp" alt="Калькулятор"
                     class="w-full h-auto mb-5"/>
                <h2 class="text-2xl font-semibold mb-6">
                    Инструкция по калькулятору
                </h2>
                <ol class="list-decimal list-outside ps-5 space-y-3">
                    <li>
                        Выберите тип расчета — облицовка стен или пола.
                    </li>
                    <li>
                        Укажите параметры помещения: длину, ширину и высоту в метрах. Если отделка будет не до
                        потолка —
                        впишите нужную высоту.
                    </li>
                    <li>
                        Введите размеры ванны в миллиметрах. Если плитка за ней укладываться не будет — оставьте
                        поля
                        пустыми или введите нули.
                    </li>
                    <li>
                        Если плитка будет использоваться в качестве экрана для ванны — активируйте соответствующий
                        пункт. Также отметьте, если ванна примыкает к трём стенам.
                    </li>
                    <li>
                        Укажите размеры дверного проема: ширину и высоту в миллиметрах.
                    </li>
                    <li>
                        Задайте параметры плитки — длину и ширину, а также её цену за квадратный метр.
                    </li>
                    <li>
                        Укажите ширину межплиточного шва в миллиметрах.
                    </li>
                    <li>
                        Выберите способ укладки плитки: прямой, со смещением или по диагонали. Это важно для расчета
                        подрезки.
                    </li>
                    <li>
                        При необходимости добавьте запас плитки: 5%, 10% или 15%. Если запас не требуется — выберите
                        «Нет».
                    </li>
                    <li>
                        Нажмите кнопку «Рассчитать», чтобы получить количество плитки, необходимое для вашего
                        помещения.
                    </li>
                </ol>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
